import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { applyInputMask, maskToPlaceholder } from "@/lib/mask";
import { RUI_CONTROL_ATTR } from "../form/control-protocol";
export function RuiInput(props) {
  const {
    class: className,
    type = "text",
    mask,
    placeholder,
    "on:input": onInput,
    ...host
  } = props;
  const resolvedPlaceholder = mask ? maskToPlaceholder(mask) : placeholder;
  const handleInput = event => {
    if (mask) {
      const input = event.target;
      input.value = applyInputMask(input.value, mask);
    }
    if (typeof onInput === "function") {
      onInput(event);
    } else if (onInput != null && typeof onInput === "object" && "handleEvent" in onInput) {
      onInput.handleEvent(event);
    }
  };
  return /* @__PURE__ */jsx("input", {
    ...host,
    type,
    placeholder: resolvedPlaceholder,
    "on:input": mask ? handleInput : onInput,
    inputmode: mask ? "numeric" : void 0,
    ...{
      [RUI_CONTROL_ATTR]: ""
    },
    "data-rui-control-type": "text",
    class: cx("rui-input", className)
  });
}